<template>
    <footer
        class="global_footer weeducStudentFooter"
        :class="{ dark }"
    >
        <div class="student-footer__inner">
            <div class="student-footer__brand">
                <img
                    :src="footerLogoSrc"
                    :alt="portalCompanyName || 'Logo'"
                />
            </div>
            <div class="student-footer__meta">
                <p class="student-footer__copyright">
                    {{ copyrightText }}
                </p>
                <p class="student-footer__version">
                    {{ versionLine }}
                </p>
            </div>
        </div>
    </footer>
</template>

<script>
import { mapState } from 'vuex';
import logoImg from '@/assets/logo.png';
import logoWhiteImg from '@/assets/logo_white.png';

export default {
    props: {
        view: {
            type: Boolean,
            default: false,
        },
    },
    inheritAttrs: false,
    data() {
        return {
            logoImg,
            logoWhiteImg,
            versionPortalWeeduc: '',
        };
    },
    computed: {
        ...mapState(['dark']),
        ...mapState('portal', ['dataWebsitePortal2']),
        portalCompanyName() {
            const w = this.dataWebsitePortal2;
            if (!w) return '';
            const raw =
                w.company?.tradeName ||
                w.company?.name ||
                w.nome ||
                w.title ||
                '';
            return String(raw).trim();
        },
        /** Logo remota do portal: no escuro usa logoFinal (tipicamente clara); no claro evita PNG branco ilegível. */
        footerLogoSrc() {
            const remote = this.dataWebsitePortal2?.logoFinal;
            if (this.dark) {
                return remote || this.logoWhiteImg;
            }
            if (
                remote &&
                !/logo_white|\/white|_white\./i.test(String(remote))
            ) {
                return remote;
            }
            return this.logoImg;
        },
        currentYear() {
            return new Date().getFullYear();
        },
        copyrightText() {
            if (this.portalCompanyName) {
                return `© ${this.currentYear} · ${this.portalCompanyName} — Todos os direitos reservados`;
            }
            return `© ${this.currentYear} - Todos os direitos reservados`;
        },
        versionLine() {
            const envVer =
                this.versionPortalWeeduc ||
                process.env.VUE_APP_VERSION_PORTAL_WEEDUC ||
                '';
            if (envVer) {
                return `Versão: ${envVer}`;
            }
            const fallback = this.formattedPortalDate;
            return fallback
                ? `Versão do portal · ${fallback}`
                : 'Versão: —';
        },
        formattedPortalDate() {
            const raw =
                this.dataWebsitePortal2?.company?.dateUpdate ||
                this.dataWebsitePortal2?.dateInsert;
            if (!raw) return '';
            try {
                const d = new Date(raw);
                if (Number.isNaN(d.getTime())) return '';
                return d.toLocaleDateString('pt-BR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric',
                });
            } catch {
                return '';
            }
        },
    },
    created() {
        this.versionPortalWeeduc =
            process.env.VUE_APP_VERSION_PORTAL_WEEDUC || '';
    },
};
</script>

<style>
@import url('./index.css');
</style>
